module.exports = __webpack_public_path__ + "img/charts-graph-bg_1.d8eee1d3.png";